import {
  fetchWebDeleteFavorite,
  TWebDeleteFavoriteRequest,
  TWebDeleteFavoriteResponse,
} from '../repositories/favorites/v1/web/delete-favorite';
import { IThunkContext } from '../types/redux';

export const deleteFavorite = (context: IThunkContext, parameters: TWebDeleteFavoriteRequest) => {
  const { httpApi, logger } = context;

  return fetchWebDeleteFavorite({ httpApi, parameters })
    .then((response: TWebDeleteFavoriteResponse) => {
      if (response.statusCode !== 200) {
        return null;
      }

      const { statusCode } = response;

      return {
        statusCode,
      };
    })
    .catch(error => {
      logger.error(error, {
        domain: 'fetchDesktopGetUserFavorites',
        details: {
          repository: 'frontend-favorites',
          service: 'favorites',
        },
      });

      throw new Error(error);
    });
};
